// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"0b8ad4ad","361":"e0b28cff","507":"0b8ad4ad","706":"d99ea1dd","714":"d99ea1dd","849":"2ed952e4"}[chunkId] + ".chunk.css";
};